// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2zXqU","ranges":"BmiRanges_ranges__2xrz-"};